import { gridStoreResults } from 'fox-react/dist/components/FoxGrid/actions';
import gridNames from 'common/gridNames';
import CurrenciesManagementSrv from './CurrenciesManagementSrv';

export function storeResults(results) {
  return gridStoreResults(gridNames.currenciesManagement)(results);
}

export function getForGrid(dataState) {
  return function(dispatch) {
    return CurrenciesManagementSrv.getForGrid(dataState).then(results => {
      dispatch(storeResults(results));
    });
  };
}

export function addAsync(model) {
  return function() {
    return CurrenciesManagementSrv.add(model);
  };
}

export function updateAsync(model) {
  return function() {
    return CurrenciesManagementSrv.update(model);
  };
}
